import { useContext } from 'react';

import { TimeseriesChartYScalesContext } from '../context/TimeseriesChartYScales.context.js';

export const useYScales = () => useContext(TimeseriesChartYScalesContext);
